// Core
import React from "react";

// Components
import Header from "../components/Header";
import Content from "../components/Content";

export default class Resume extends React.Component {
    render () {
        return (
            <>
                <Header />
                <Content />
            </>
        );
    }
}
